import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RequestsService {
  private readonly pendingRequestList = new BehaviorSubject<any>(null);
  private readonly providedRequestList = new BehaviorSubject<any>(null);
  private readonly historyRequestList = new BehaviorSubject<any>(null);

  constructor(private readonly http: HttpClient) {}

  getAllPendingRequests() {
    let url = `${environment.baseUrl}/requests/pending`;
    this.http.get(url).subscribe((pending) => {
      this.pendingRequestList.next(pending);
    });
  }
  getPendingRequestList() {
    return this.pendingRequestList
      .asObservable()
      .pipe(filter((data) => data !== null));
  }

  getAllProvidedRequests() {
    let url = `${environment.baseUrl}/requests/provisioned`;
    this.http.get(url).subscribe((pending) => {
      this.providedRequestList.next(pending);
    });
  }
  getProvidedRequestList() {
    return this.providedRequestList
      .asObservable()
      .pipe(filter((data) => data !== null));
  }

  getAllHistoryRequests() {
    let url = `${environment.baseUrl}/requests/history`;
    this.http.get(url).subscribe((pending) => {
      this.historyRequestList.next(pending);
    });
  }
  getHistoryRequestList() {
    return this.historyRequestList
      .asObservable()
      .pipe(filter((data) => data !== null));
  }

  getRequest(requestId: string) {
    let url = `${environment.baseUrl}/requests/${requestId}`;
    return this.http.get(url);
  }

  getFormByRenew(renewId: string) {
    let url = `${environment.baseUrl}/requests/${renewId}`;
    return this.http.get(url);
  }

  completeRenew(data: any) {
    let url = `${environment.baseUrl}/actions/${data.currentActionId}/complete`;
    return this.http.put(url, data.form);
  }

  newRequest(formData: any) {
    let url = `${environment.baseUrl}/requests`;
    return this.http.post(url, formData);
  }

  transferRequest(requestId: string) {
    let url = `${environment.baseUrl}/requests/${requestId}/transfer/`;
    return this.http.post(url, {});
  }

  withdrawRequest(requestId: string) {
    let url = `${environment.baseUrl}/requests/${requestId}/withdraw`;
    return this.http.put(url, {});
  }

  newDeprovisioning(requestId: string) {
    let url = `${environment.baseUrl}/requests/${requestId}/deprovision`;
    return this.http.post(url, {});
  }

  getTransfer(requestId: string) {
    let url = `${environment.baseUrl}/requests/${requestId}/transfer`;
    return this.http.get(url);
  }

  getRenew(requestId: string) {
    let url = `${environment.baseUrl}/requests/${requestId}/renew`;
    return this.http.get(url, {});
  }

  getDeprovisioning(requestId: string) {
    let url = `${environment.baseUrl}/requests/${requestId}/deprovision`;
    return this.http.get(url);
  }

  getHistory(requestId: string) {
    let url = `${environment.baseUrl}/requests/${requestId}/history`;
    return this.http.get(url);
  }
}
